import {
  type Competition,
  type Participant,
  type Person,
  type Tournament,
} from '@clubspark-node/clubspark-tennis-types';

export const transform = (inputTournament: Tournament, competition: Competition) => {
  // Transformation to tournament engine format
  const venues = competition?.venues?.filter((venue) =>
    inputTournament?.venueIds?.map((venue) => venue)?.includes(venue.venueId),
  );
  const persons = competition?.persons;
  return {
    ...inputTournament,
    participants: convertParticipants(inputTournament.participants, persons),
    venues: venues || inputTournament.venues,
  };
};

function convertParticipants(participants: Participant[], persons: Person[]) {
  if (!participants) {
    return [];
  }
  return participants.map((participant: Participant) => {
    return {
      ...participant,
      person: participant.person || persons?.find((person) => participant.personId === person.personId),
      timeItems: participant.timeItems || [],
    };
  });
}
